$ ->
  $(document).on 'click', '[data-table-filter-reset]', (e) ->
    e.preventDefault()
    form = $(@).closest('form')
    input = form.find('input[type="text"]')
    input.val('')
    form.submit()